/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetFileStatsQueryResponse, IngestionStatusControllerGetFileStatsQueryParams, IngestionStatusControllerGetFileStats403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetFileStats";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { ingestionStatusControllerGetFileStats } from "../../clients/document-ingestion-statusService/ingestionStatusControllerGetFileStats";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const ingestionStatusControllerGetFileStatsQueryKey = (params: IngestionStatusControllerGetFileStatsQueryParams = {}) => [{
  url: '/api/v1/documents/ingestion-status/files'
}, ...(params ? [params] : [])] as const;
export type IngestionStatusControllerGetFileStatsQueryKey = ReturnType<typeof ingestionStatusControllerGetFileStatsQueryKey>;
export function ingestionStatusControllerGetFileStatsQueryOptions(params?: IngestionStatusControllerGetFileStatsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = ingestionStatusControllerGetFileStatsQueryKey(params);
  return queryOptions<IngestionStatusControllerGetFileStatsQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetFileStats403>, IngestionStatusControllerGetFileStatsQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return ingestionStatusControllerGetFileStats(params, config);
    }
  });
}

/**
 * @description Returns statistics about file uploads and processing, including counts by status, success rates, and time series data. Requires System Administrator role.
 * @summary Get file ingestion statistics
 * {@link /api/v1/documents/ingestion-status/files}
 */
export function useIngestionStatusControllerGetFileStats<TData = IngestionStatusControllerGetFileStatsQueryResponse, TQueryData = IngestionStatusControllerGetFileStatsQueryResponse, TQueryKey extends QueryKey = IngestionStatusControllerGetFileStatsQueryKey>(params?: IngestionStatusControllerGetFileStatsQueryParams, options: {
  query?: Partial<QueryObserverOptions<IngestionStatusControllerGetFileStatsQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetFileStats403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? ingestionStatusControllerGetFileStatsQueryKey(params);
  const query = useQuery({
    ...ingestionStatusControllerGetFileStatsQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IngestionStatusControllerGetFileStats403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}